import * as __WEBPACK_EXTERNAL_MODULE__palette_foreground_js_cd973cd4__ from "./palette/foreground.js";
import * as __WEBPACK_EXTERNAL_MODULE__text_baseTextVariants_js_a7295e82__ from "./text/baseTextVariants.js";
import * as __WEBPACK_EXTERNAL_MODULE__tv_js_7c4f7b16__ from "./tv.js";
const textAlignVariants = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
    justify: 'text-justify'
};
const textAligns = Object.keys(textAlignVariants);
const textOverflowVariants = {
    truncate: 'truncate',
    ellipsis: 'text-ellipsis overflow-hidden',
    clip: 'text-clip overflow-hidden'
};
const textOverflows = Object.keys(textOverflowVariants);
const textWrapVariants = {
    wrap: 'text-wrap',
    nowrap: 'text-nowrap',
    balance: 'text-balance',
    pretty: 'text-pretty'
};
const textWraps = Object.keys(textWrapVariants);
const lineClampVariants = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    6: 'line-clamp-6',
    none: 'line-clamp-none'
};
const lineClamps = Object.keys(lineClampVariants);
const wordBreakVariants = {
    breakNormal: 'break-normal',
    breakWords: 'break-words',
    breakKeep: 'break-keep'
};
const wordBreaks = Object.keys(wordBreakVariants);
const textVariants = (0, __WEBPACK_EXTERNAL_MODULE__tv_js_7c4f7b16__.tv)({
    extend: __WEBPACK_EXTERNAL_MODULE__palette_foreground_js_cd973cd4__.foregroundPaletteVariants,
    variants: {
        textStyle: __WEBPACK_EXTERNAL_MODULE__text_baseTextVariants_js_a7295e82__.textStyleVariants,
        italic: {
            true: 'italic'
        },
        bold: {
            true: 'font-bold'
        },
        align: textAlignVariants,
        underline: {
            solid: 'underline underline-offset-2',
            dashed: 'underline decoration-dashed underline-offset-4',
            none: 'no-underline'
        },
        strikethrough: {
            true: 'line-through'
        },
        uppercase: {
            true: 'uppercase'
        },
        overflow: textOverflowVariants,
        lineClamp: lineClampVariants,
        textWrap: textWrapVariants,
        wordBreak: wordBreakVariants
    },
    defaultVariants: {}
});
const textVariantsFields = Object.keys(textVariants.variants);
const textUnderlines = Object.keys(textVariants.variants.underline);
const headingAsVariants = {
    h1: 'text-heading1',
    h2: 'text-heading2',
    h3: 'text-heading3',
    h4: 'text-heading4',
    h5: 'text-heading5',
    h6: 'text-heading6'
};
const headingAs = Object.keys(headingAsVariants);
const headingVariants = (0, __WEBPACK_EXTERNAL_MODULE__tv_js_7c4f7b16__.tv)({
    extend: textVariants,
    variants: {
        as: headingAsVariants
    },
    defaultVariants: {
        as: 'h1',
        shade: '11'
    }
});
export { headingAs, headingAsVariants, headingVariants, lineClampVariants, lineClamps, textAlignVariants, textAligns, textOverflowVariants, textOverflows, textUnderlines, textVariants, textVariantsFields, textWrapVariants, textWraps, wordBreakVariants, wordBreaks };
